var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashAndMarketables(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9997 19.33V15.2C50.9997 14.11 50.1097 13.22 49.0197 13.22H45.2397C45.2297 13.33 45.2197 13.44 45.2197 13.55C45.2297 16.75 47.8097 19.33 50.9997 19.33Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0005 38.51V34.71C47.8105 34.71 45.2305 37.3 45.2305 40.48H49.0305C50.1105 40.49 51.0005 39.6 51.0005 38.51Z",
    fill: "#FFCF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77 13.56C6.77 13.45 6.76 13.34 6.75 13.23H2.98C1.89 13.23 1 14.11 1 15.21V19.34C4.19 19.33 6.77 16.75 6.77 13.56Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 34.71V38.51C1 39.6 1.89 40.49 2.98 40.49H6.78C6.77 37.3 4.19 34.71 1 34.71Z",
    fill: "#FFCF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9998 34.71V19.33C47.8098 19.33 45.2298 16.74 45.2298 13.56C45.2298 13.45 45.2398 13.34 45.2498 13.23H6.75977C6.76977 13.34 6.77977 13.45 6.77977 13.56C6.77977 16.75 4.18977 19.33 1.00977 19.33V34.71C4.19977 34.71 6.77977 37.3 6.77977 40.48H45.2298C45.2298 37.3 47.8098 34.71 50.9998 34.71Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 37C31.6005 37 36.1404 32.4601 36.1404 26.86C36.1404 21.2598 31.6005 16.72 26.0004 16.72C20.4002 16.72 15.8604 21.2598 15.8604 26.86C15.8604 32.4601 20.4002 37 26.0004 37Z",
    fill: "#FFCF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 37C31.6005 37 36.1404 32.4601 36.1404 26.86C36.1404 21.2598 31.6005 16.72 26.0004 16.72C20.4002 16.72 15.8604 21.2598 15.8604 26.86C15.8604 32.4601 20.4002 37 26.0004 37Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9998 34.71V19.33C47.8098 19.33 45.2298 16.74 45.2298 13.56C45.2298 13.45 45.2398 13.34 45.2498 13.23H6.75977C6.76977 13.34 6.77977 13.45 6.77977 13.56C6.77977 16.75 4.18977 19.33 1.00977 19.33V34.71C4.19977 34.71 6.77977 37.3 6.77977 40.48H45.2298C45.2298 37.3 47.8098 34.71 50.9998 34.71Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9997 19.33V15.2C50.9997 14.11 50.1097 13.22 49.0197 13.22H45.2397C45.2297 13.33 45.2197 13.44 45.2197 13.55C45.2297 16.75 47.8097 19.33 50.9997 19.33Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0005 38.51V34.71C47.8105 34.71 45.2305 37.3 45.2305 40.48H49.0305C50.1105 40.49 51.0005 39.6 51.0005 38.51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77 13.56C6.77 13.45 6.76 13.34 6.75 13.23H2.98C1.89 13.23 1 14.11 1 15.21V19.34C4.19 19.33 6.77 16.75 6.77 13.56Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 34.71V38.51C1 39.6 1.89 40.49 2.98 40.49H6.78C6.77 37.3 4.19 34.71 1 34.71Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashAndMarketables);
export default __webpack_public_path__ + "static/media/CashAndMarketables.e8d59fde66b61bdee4a0ced8922b186b.svg";
export { ForwardRef as ReactComponent };